export function logOut(redirectUrl = "/") {
  sessionStorage.clear();
  window.location.assign(redirectUrl);
}
